import { useEffect, useMemo } from "react";
import { useConsent } from "@/context/consent";

const UTM_COOKIE_NAME = "__apsu_utm";
const UTM_KEYS = [
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_content",
] as const;

function readUtmCookie(): Record<string, string> | null {
	const match = document.cookie
		.split("; ")
		.find((row) => row.startsWith(`${UTM_COOKIE_NAME}=`));
	if (!match) return null;
	try {
		return JSON.parse(decodeURIComponent(match.split("=").slice(1).join("=")));
	} catch {
		return null;
	}
}

function writeUtmCookie(data: Record<string, string>): void {
	const value = encodeURIComponent(JSON.stringify(data));
	// biome-ignore lint/suspicious/noDocumentCookie: Cookie Store API lacks broad support
	document.cookie = `${UTM_COOKIE_NAME}=${value}; Path=/; SameSite=Lax; Max-Age=2592000`;
}

export function useUtm(): Record<string, string> | null {
	const { analytics } = useConsent();

	useEffect(() => {
		if (analytics) {
			const url = new URL(window.location.href);
			const params: Record<string, string> = {};
			let found = false;
			for (const key of UTM_KEYS) {
				const val = url.searchParams.get(key);
				if (val) {
					params[key] = val;
					found = true;
				}
			}

			if (found) {
				writeUtmCookie(params);
			}
		} else {
			// biome-ignore lint/suspicious/noDocumentCookie: Cookie Store API lacks broad support
			document.cookie = `${UTM_COOKIE_NAME}=; Path=/; SameSite=Lax; Max-Age=0`;
		}
	}, [analytics]);

	return useMemo(() => readUtmCookie(), []);
}
